const tabs = {
    actions: 'Actions',
    get_started: 'Rozpocznij',
    dashboard: 'Panel',
    applications: 'Aplikacje',
    api_resources: 'Zasoby API',
    sign_in_experience: 'Logowanie i konto',
    connectors: 'Konnektory',
    enterprise_sso: 'Enterprise SSO',
    security: 'Bezpieczeństwo',
    webhooks: 'Webhooki',
    organizations: 'Organizacje',
    users: 'Zarządzanie użytkownikami',
    audit_logs: 'Dzienniki audytu',
    roles: 'Role',
    docs: 'Dokumentacja',
    tenant_settings: 'Ustawienia',
    mfa: 'Multi-factor auth',
    customize_jwt: 'Niestandardowy JWT',
    signing_keys: 'Klucze do podpisu',
    organization_template: 'Szablon organizacji',
};
export default Object.freeze(tabs);
